export enum TelematicsRemainingFuelFilter {
  UNDER_10_PERCENTAGE = 'under-10-percentage',
  UNDER_25_PERCENTAGE = 'under-25-percentage',
}
